module.exports = __webpack_public_path__ + "static/media/Porygon_gaussian2.19537cb9.png";